import { render, staticRenderFns } from "./SvgMarker.vue?vue&type=template&id=246f7fd2&scoped=true&"
import script from "./SvgMarker.vue?vue&type=script&lang=js&"
export * from "./SvgMarker.vue?vue&type=script&lang=js&"
import style0 from "./SvgMarker.vue?vue&type=style&index=0&id=246f7fd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246f7fd2",
  null
  
)

export default component.exports